import { useIsHydrating } from '@muse-web/router'

import { TABLET_UP_MEDIA_QUERY } from './breakpoints'
import { useSharedMediaQuery } from './useSharedMediaQuery'

export const useIsTabletUp = (): boolean => {
    const matchesTabletUp = useSharedMediaQuery(TABLET_UP_MEDIA_QUERY)
    const isHydrating = useIsHydrating()

    // The server prints the phone half, and Preact reads the real media query on its very first
    // client render — so the swap has to wait for hydration to finish or the DOM is reconciled wrong.
    return matchesTabletUp && !isHydrating
}
